<style scoped lang="scss" type="text/scss">
  .type-selector-panel {
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;

        .type-item {
            margin-bottom: 0;
            margin-right: .25rem;
            width: 4.75rem;
            min-width: 4.75rem;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
    .select {
        margin-top: 51px;
        margin-left: 700px;
    }

    .event-query {
        height: 40px;
        width: 68px;
        margin-top: 51px;
        margin-left: 12px;
    }
</style>

<template>
    <div class="type-selector-panel">
        <square-info-block class="type-item" v-for="(item, index) in items" :key="index" :icon="item.icon"
            :with-angle="false" :active="routeName === item.route_name" @click.native="redirect(item.route_name)">
            {{ item.title }}
        </square-info-block>
        <el-select class="select" v-model="competitionValue" clearable placeholder="根据赛事名称进行筛选" style="width: 300px">
            <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
        <el-button class="event-query" type="primary" @click="search">
            筛选
        </el-button>
    </div>
</template>

<script>
import SquareInfoBlock from "../../../../../components/square-info-block/index";
import ROUTE_NAMES from "../../../../../router/names";

export default {
    name: "",
    components: {
        SquareInfoBlock,
    },
    data() {
        return {
            items: [
                {
                    title: "中期检查",
                    icon: "&#xe618;",
                    route_name: ROUTE_NAMES.ADMIN.MIDDLE.MIDDLECHECK_OVERVIEW,
                },
            ],
            options: [],
            competitionValue: "",
            competitionList: [],
        };
    },
    created() {
        this.$EventBus.$on("shareData", (val) => {
            this.competitionList = val;
            let arr = [];
            let newArr = [];
            val.forEach((item) => {
                const obj = {
                    value: item.name,
                    label: item.name,
                };
                arr.push(obj);
            });
            arr.forEach((item) => {
                if (!newArr.includes(item.name)) {
                    newArr.push(item);
                }
            });
            this.options = newArr;
            // console.log("下拉框", this.options);
        });
    },
  computed: {
            routeName () {
                return this.$route.name;
            }
        },
    methods: {
        search() {
            // console.log(this.competitionValue);
            if (this.competitionValue != "") {
                let arr = [];
                this.competitionList.forEach((item) => {
                    item.main = 0;
                    if (item.name == this.competitionValue) {
                        // console.log(item);
                        item.main = 1;
                        arr.push(item);
                        this.$EventBus.$emit("sharecompetitionData", arr);
                    }
                });
            } else {
                this.$EventBus.$emit("sharecompetitionData", this.competitionList);
            }
        },
        redirect(routeName) {
            this.$router.push({
                name: routeName,
            });
        },
    },
};
</script>